export default __webpack_public_path__ + "static/extreme-774d5a9d2215db5532f14ed17da1d0a7.png";